import React from "react";

const AccountConfigurationTitle = () => {
  return (
    <h3>
      Preferences
      <small>
        Customize feature access, notification preferences, and alert protocols
        for each account.
      </small>
    </h3>
  );
};

export default AccountConfigurationTitle;
